<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2">A Better Freedom</h2>
<p class="body">Christ revealed himself to me</p>
<p class="body">Enslaved my soul to set me free</p>
<p class="body">I was bound to at him at Calvary</p>
<p class="body">And found a better freedom</p>
<p class="verse"> </p>
<p class="body">That Soul who suffered in the dark</p>
<p class="body">Has purchased and unchained my heart</p>
<p class="body">A shining slavery did impart</p>
<p class="body">To find a better freedom</p>
<p class="verse"> </p>
<p class="i">A better freedom can’t be found</p>
<p class="i">By those unwilling to be bound</p>
<p class="i">A better freedom is not known</p>
<p class="i">By those whose hearts will not be owned</p>
<p class="i">But those who follow find a better freedom</p>
<p class="verse"> </p>
<p class="body">We never can be truly free</p>
<p class="body">Till we’re bound to this community</p>
<p class="body">The Incarnation lets us see</p>
<p class="body">A path to better freedom</p>
<p class="verse"> </p>
<p class="body">A slave to sin, my heart before</p>
<p class="body">Was bolted like a prison door</p>
<p class="body">But in slavery to the Risen Lord</p>
<p class="body">I found a better freedom</p>
<p class="verse"> </p>
<p class="i">A better freedom can’t be found</p>
<p class="i">By those unwilling to be bound</p>
<p class="i">A better freedom is not known</p>
<p class="i">By those whose hearts will not be owned</p>
<p class="i">But those who follow find a better freedom</p>
<p class="verse"> </p>
<p class="i">Come with him and find a better freedom</p>
<p class="i">Follow me and find a better freedom</p>
<p class="verse"> </p>
<p class="small">Music and lyrics by Scott Roley and Michael Card</p>
<p class="small">(Recording available for free download at <a href="http://michaelcard.com" target="_blank">michaelcard.com</a>)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ABetterFreedom.vue?0fddf3bb